import { useState, useEffect } from "react";
import { Box, Flex, Button } from "@chakra-ui/react";
import rem from "@/utils/rem";
import { useFeatureFlag } from "@/services/featureFlags";
import { FEATURE_FLAGS } from "@/constants/featureFlags";

const BANNER_KEY = "global-banner-dismissed";

const GlobalBanner = () => {
    const { isEnabled: globalBannerEnabled, description: bannerDescription } = useFeatureFlag(FEATURE_FLAGS.FEATURE_GLOBAL_DISMISSIBLE_BANNER, false);
    const { isEnabled: globalStaticBannerEnabled, description: staticBannerDescription } = useFeatureFlag(FEATURE_FLAGS.FEATURE_GLOBAL_STATIC_BANNER, false);
    const [isBannerDismissed, setIsBannerDismissed] = useState(false);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const dismissed = localStorage.getItem(BANNER_KEY) === "true";
        setIsBannerDismissed(dismissed);
        setIsReady(true);
    }, []);

    const handleDismissBanner = () => {
        localStorage.setItem(BANNER_KEY, "true");
        setIsBannerDismissed(true);
    };

    if (!isReady) {
        return null;
    }

    if (globalStaticBannerEnabled) {
        return (
            <Flex position="relative" alignItems="center" justifyContent="center" width="full" padding={rem(8)} color="black" background="white">
                <Box fontSize={rem(13)} textAlign="center">
                    {staticBannerDescription}
                </Box>
            </Flex>
        );
    }

    if (globalBannerEnabled && !isBannerDismissed) {
        return (
            <Flex 
                position="relative" 
                alignItems="center" 
                justifyContent="center" 
                flexDirection={{ base: "column", md: "row" }}
                gap={{ base: rem(8), md: 0 }}
                width="full" 
                padding={rem(8)} 
                color="black" 
                background="white"
            >
                <Box 
                    flex="1" 
                    paddingRight={{ base: 0, md: rem(120) }}
                    fontSize={rem(13)} 
                    textAlign="center"
                >
                    {bannerDescription}
                </Box>
                <Button
                    position={{ base: "relative", md: "absolute" }}
                    right={{ base: "auto", md: rem(8) }}
                    marginRight={{ base: 0, md: rem(14) }}
                    color="black"
                    border={`${rem(1)} solid var(--chakra-colors-stroke-primary)`}
                    _hover={{ bg: "gray.100" }}
                    onClick={handleDismissBanner}
                    size="xs"
                    variant="ghost"
                >
                    Dismiss
                </Button>
            </Flex>
        );
    }

    return null;
};

export default GlobalBanner;